/*
Copyright © 2021 EPAM Systems, Inc. All Rights Reserved.
All information contained herein is, and remains the property of EPAM Systems, Inc.
and/or its suppliers and is protected by international intellectual property law.
Dissemination of this information or reproduction of this material is strictly
forbidden, unless prior written permission is obtained from EPAM Systems, Inc
*/
import React, { useState } from 'react';
import { ClickOutside } from '../ClickOutside';
import { DatePicker } from './Datepicker';
import { CalendarInput } from './CalendarInput';

import './calendar.scss';

const calendar = require('b_').with('custom-calendar');

export const Calendar = ({
    onChange, value, calendarPeriodDuration = 1, pickerStartDate, ...props
}) => {
    const [ isVisible, toggleVisibility ] = useState(false);

    return (
        <ClickOutside onClick={() => isVisible && toggleVisibility(false)} open={isVisible}>
            <div className={calendar('wrapper')}>
                <CalendarInput
                    {...props}
                    value={value}
                    calendarPeriodDuration={calendarPeriodDuration}
                    onChange={onChange}
                    onClickIcon={() => toggleVisibility(!isVisible)}
                />
                {/* <DatePicker
                    {...props}
                    isVisible={isVisible}
                    value={value}
                    calendarPeriodDuration={calendarPeriodDuration}
                    onChange={onChange}
                    toggleVisibility={toggleVisibility}
                    pickerStartDate={pickerStartDate}
                /> */}
            </div>
        </ClickOutside>
    );
};
